import React, { useEffect, useState } from "react";
import {
  DeprecationContainer,
  ContentBox,
  LogoContainer,
  Logo,
  Title,
  Subtitle,
  Divider,
  Message,
  LinkBox,
  Link,
  Description,
  WarningBox,
  DeprecationWarning,
  CountdownText,
} from "./DeprecationNotice.styles";

export const DeprecationNotice: React.FC = () => {
  const [countdown, setCountdown] = useState(5);
  const targetUrl = "https://platform.andeslatam.tech/";

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          window.location.href = targetUrl;
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.location.href = targetUrl;
  };

  return (
    <DeprecationContainer>
      <ContentBox>
        <LogoContainer>
          <Logo src="/assets/pics/logo-andes.png" alt="ANDES Logo" />
        </LogoContainer>

        <Title>ANDES Chat</Title>
        <Subtitle>Ha sido migrado a una nueva plataforma</Subtitle>

        <Divider />

        <Message>Ahora puedes acceder desde</Message>

        <LinkBox>
          <Link
            href={targetUrl}
            onClick={handleLinkClick}
          >
            platform.andeslatam.tech
          </Link>
        </LinkBox>

        <Description>
          Todas las funcionalidades que conoces están disponibles en la nueva plataforma,
          con mejoras en rendimiento y nuevas características.
        </Description>

        <WarningBox>
          <DeprecationWarning>
            ⚠️ Este proyecto está deprecado y se eliminará próximamente
          </DeprecationWarning>
        </WarningBox>

        <CountdownText>
          Serás redirigido automáticamente en <span>{countdown}</span> segundos
        </CountdownText>
      </ContentBox>
    </DeprecationContainer>
  );
};
